import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ButtonComponent } from "../elements";
import { SidebarContext } from "../../context/Sidebar";

export default function FollowupTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(20); // Change as needed
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [editModal, setEditModal] = useState(false);
    const [blockModal, setBlockModal] = useState(false);
    const { hasPermission } = useContext(SidebarContext);
    const [expanded, setExpanded] = useState({});

    const toggleExpanded = (personId) =>
        setExpanded((prev) => ({ ...prev, [personId]: !prev[personId] }));

    useEffect(() => {
        setData(tbody);
    }, [tbody]);

    useEffect(() => {
        const filtered = data.filter(item =>
            item.beneficiary_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.beneficiary_cnic.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.fsf_id.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page on search
    }, [searchTerm, data]);


   

    // Pagination
    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="mc-table-responsive">
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder={t("search_here")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={index}>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentRows.map((item) => (
                        <React.Fragment key={item.person_id}>
                        <tr>
                            <td title={item?.fsf_id}>{item?.fsf_id}</td>
                            <td title={item?.beneficiary_cnic}>{item?.beneficiary_cnic}</td>
                            <td title={item?.beneficiary_name}>{item?.beneficiary_name}</td>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light text-dark"
                                    title="Show follow-ups"
                                    onClick={() => toggleExpanded(item.person_id)}
                                >
                                    {item.followup_count} Follow-up{item.followup_count === 1 ? "" : "s"}
                                    {" "}{expanded[item.person_id] ? "▲" : "▼"}
                                </button>
                            </td>
                            <td title={item?.last_visit}>{item?.last_visit}</td>
                            <td>
                                <div className="mc-table-action">
                                     {hasPermission("CanEditFollowup") && (
                                    <ButtonComponent
                                        title="Edit All Follow-ups"
                                        className="material-icons edit"
                                        onClick={() =>
                                            navigate(`/edit-family-follow-ups/${item.person_id}`)
                                        }
                                    >
                                        {item?.action?.edit}
                                    </ButtonComponent>
                                     )}
                                </div>
                            </td>
                        </tr>
                        {expanded[item.person_id] && item.followups.map((followup) => (
                            <tr key={`${item.person_id}-${followup.id}`} style={{ background: "#f6f6f6" }}>
                                <td></td>
                                <td colSpan={2} title={followup?.user_name}>
                                    Entered By: {followup?.user_name}
                                </td>
                                <td title={followup?.followup}>{followup?.followup}</td>
                                <td title={followup?.date_of_visit}>{followup?.date_of_visit}</td>
                                <td>
                                    <div className="mc-table-action">
                                        <ButtonComponent
                                            title="View"
                                            className="material-icons view"
                                            onClick={() =>
                                                navigate(`/view-follow-up/${followup.id}`)
                                            }
                                        >
                                            {item?.action?.view}
                                        </ButtonComponent>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-center mt-3">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(num => (
                    <button
                        key={num}
                        className={`btn btn-sm mx-1 ${currentPage === num ? "btn-primary" : "btn-light text-dark"}`}
                        onClick={() => paginate(num)}
                    >
                        {num}
                    </button>
                ))}
            </div>

           
        </div>
    );
}
